import React from 'react';
import PropTypes from 'prop-types';

import DateTime from '../DateTime';

const CollectionsDate = ({ collection }) => (
  <DateTime
    id={`collection-date-${collection.uuid}`}
    className="collection-date"
    dateTime={collection.created_at}
  />
);

CollectionsDate.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default CollectionsDate;
